<script setup>
import {onMounted, ref} from 'vue';

const currentMonth = ref('')

onMounted(() => {
  const now = new Date();
  const day = now.getDate();
  let month = now.getMonth();

  if (day >= 1 && day <= 15) {
    month -= 2;
  } else {
    month -= 1;
  }

  /**
   * Ajustamos el mes si cae fuera del rango para manejar el cambio de año.
   * Los meses en JavaScript van de 0 a 11 (0 = enero, 11 = diciembre),
   * así que al restar meses al inicio del año, podemos caer en números negativos.
   * Por ejemplo, si estamos en enero (0) y restamos 2, obtenemos -2.
   * Para corregir esto, sumamos 12, lo cual convierte -1 en 11 (diciembre)
   * y -2 en 10 (noviembre), obteniendo el mes del año anterior.
   */

  if (month < 0) {
    month += 12;
  }

  const monthNames = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  currentMonth.value = monthNames[month];
});
</script>

<template>
  <div
    class="floating-message"
    id="floating-message"
  >
    <span>Mes monitoreado: {{ currentMonth }}</span>
  </div>
</template>


<style scoped>
.floating-message {
  position: fixed;
  bottom: 17px;
  right: 5px;
  background-color: rgb(0,72,255);
  color: white;
  padding: 15px;
  border-radius: 8px;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>